<template>
    <button
        v-back-to-top
        class="btn-back-to-top"
        @click="backToTop">
        <i class="iconfont icon-up"></i>
    </button>
</template>

<script>
import utils from '@/assets/scripts/utils';

export default {
    directives: {
        backToTop: function (el) {
            el.handler = () => {
                if (utils.getScrollTop() > window.innerHeight / 2) {
                    el.style.display = 'block';
                } else {
                    el.style.display = 'none';
                }
            };
            window.addEventListener('scroll', el.handler);
        },
    },

    methods: {
        backToTop() {
            window.scrollTo(0, 0);
        },
    },
};
</script>

<style lang="scss">
.btn-back-to-top {
    font-size: 24px;
    color: #fff;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #aaa;
    display: none;

    position: fixed;
    bottom: 10px;
    right: 20px;

    &:hover {
        background: #666;
    }

    @include media-mob {
        // display: none !important;
    }
}
</style>
